import { Controller } from "@hotwired/stimulus"
/**
 * Stimulus controller to reset form fields.
 * 
 * Features:
 *  - Clears all input fields, textareas, and selects.
 *  - Resets checkboxes and radio buttons.
 *  - Handles custom select elements (updates the displayed value and selected class).
 * 
 * Usage:
 *  - Add `data-controller="form-reset"` to the form or a parent element.
 *  - Add `data-form-reset-target="form"` to the <form> element itself.
 *  - Add a button with `data-action="form-reset#clearFields"` to trigger the reset.
 */
export default class extends Controller {
  static targets = ["form"]

  connect() {  }

  clearFields(event) {
    event.preventDefault()
    const form = this.formTarget || this.element.closest("form")
    if (!form) return

    // Reset all input, select, textarea elements
    form.querySelectorAll("input, select, textarea").forEach(el => {
      if (["button", "submit", "reset", "hidden"].includes(el.type)) return

      if (["checkbox", "radio"].includes(el.type)) {
        el.checked = false
      } else if (el.tagName.toLowerCase() === "select") {
        el.selectedIndex = 0 // Reset native select to first option

        // Update custom select display if present
        const container = el.parentElement
        const displayed = container.querySelector(".select-selected")
        if (displayed && el.options.length > 0) {
          displayed.textContent = el.options[0].textContent
        }

        // Reset custom select item classes
        const items = container.querySelectorAll(".select-items div")
        items.forEach(item => item.classList.remove("same-as-selected"))
        if (items.length > 0) items[0].classList.add("same-as-selected")
      } else {
        el.value = "" // Clear text fields and textareas
      }
    })
  }
}
